export const ASSETS_SHOWING = 'ASSETS_SHOWING'